export class IeDesaturate {
    constructor(public htmlElement: any) {
        if (this.getInternetExplorerVersion() >= 10) {
            this.htmlElement.classList.add('ie' + this.getInternetExplorerVersion());
            var desaturateImages = [].slice.call(document.querySelectorAll('.desaturate img'));
            desaturateImages.forEach(img => {
                this.grayscaleIE10(img);
            });
        }
    }
    getInternetExplorerVersion() {
        var rv = -1;
        if (navigator.appName == 'Microsoft Internet Explorer') {
            var ua = navigator.userAgent;
            var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
            if (re.exec(ua) != null)
                rv = parseFloat(RegExp.$1);
        }
        else if (navigator.appName == 'Netscape') {
            var ua = navigator.userAgent;
            var re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
            if (re.exec(ua) != null)
                rv = parseFloat(RegExp.$1);
        }
        return rv;
    }
    grayscaleIE10(img) {
        let imgObj = img;
        imgObj.src = this.gray(imgObj);
    };
    gray(imgObject) {
        var canvas = document.createElement('canvas');
        var canvasContext = canvas.getContext('2d');
        var imgW = imgObject.naturalWidth;
        var imgH = imgObject.naturalHeight;
        canvas.width = imgW;
        canvas.height = imgH;
        canvasContext.drawImage(imgObject, 0, 0);
        var imgPixels = canvasContext.getImageData(0, 0, imgW, imgH);
        for (var y = 0; y < imgPixels.height; y++) {
            for (var x = 0; x < imgPixels.width; x++) {
                var i = (y * 4) * imgPixels.width + x * 4;
                var avg = (imgPixels.data[i] + imgPixels.data[i + 1] + imgPixels.data[i + 2]) / 3;
                imgPixels.data[i] = avg;
                imgPixels.data[i + 1] = avg;
                imgPixels.data[i + 2] = avg;
            }
        }
        canvasContext.putImageData(imgPixels, 0, 0, 0, 0, imgPixels.width, imgPixels.height);
        return canvas.toDataURL();
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/ie-desaturate.ts